import { SET_COUNTRY, SET_COUNTRIES} from "../actions/types";

const initialState = {
  country: {},
  countries: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_COUNTRY:
      return {
        ...state,
        country: action.country
      };
    case SET_COUNTRIES:
      return {
        ...state,
        countries: action.countries
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/country.js